import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../openapi";
import { IRootState } from "./app/store";
import { isSystemAdminEmail } from "@multiconsult-group/multiplacer-core";

export const selectHttpCurrentUser = createSelector([(state: IRootState) => state], (state) => {
  const result = openapi.endpoints.getAuthMe.select(undefined)(state);
  return result.data ?? null;
});

export const selectIsSystemAdmin = createSelector([selectHttpCurrentUser], (user) => {
  if (!user || !user.email) {
    return false;
  }

  return isSystemAdminEmail(user.email);
});

export const selectIsExternalUser = createSelector([selectHttpCurrentUser], (user) => {
  if (!user) {
    return false;
  }
  return user.isExternal;
});
